import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router/router'
import './app.css'
import VeeValidate from 'vee-validate'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import FaqHeader from './views/Faq/FaqHeader.vue'
import FaqScalableDescription from './views/Faq/FaqScalableDescription.vue'
import FaqBody from './views/Faq/FaqBody.vue'
Vue.use(Vuetify)

Vue.config.productionTip = false

Vue.component('faq-header', FaqHeader)
Vue.component('faq-scalable-description', FaqScalableDescription)
Vue.component('faq-body', FaqBody)
Vue.use(VeeValidate, {
  validity: true,
})

new Vue({
  router,
  store,
  render: function(h) {
    return h(App)
  },
}).$mount('#app')
